export const colors = {
  mint: "#8BAAAD",
  teal: "#B9E3C6",
  purplegrey: "#7F7B82",
  offwhite: "#DFE0E2",
  white: "#FDFFFC",
  black: "#303838",
  lightgrey: "#CCCCCC",
  grey: "#28262C",
  darkgrey: "rgba(46, 46, 46, 0.96)",
  slategrey: "#424B54",
  outerspace: "#26282D",
  paleblue: "#93B2BF",
  blue: "#416788",
  deeppurple: "#5A114B",
  vermilion: "#ED6A5A",
  deeperpurple: "#49516F",
  darkpurple: "#36213E",
  jet: "#292F36",
};
